var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideoCameraDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4413 12L11.9395 13.4982L13.0001 12.4375L11.3333 10.7707V9L14 11.6667V4.33333L11.3333 7V4.66667C11.3333 4.48986 11.2631 4.32029 11.1381 4.19526C11.013 4.07024 10.8435 4 10.6667 4H4.56261L3.00011 2.4375L1.93945 3.49816L2.47073 4.02944C2.36769 4.06113 2.27289 4.11763 2.19526 4.19526C2.07024 4.32029 2 4.48986 2 4.66667V4.66749C2 4.49068 2.07024 4.32111 2.19526 4.19608C2.26904 4.1223 2.35834 4.0676 2.45548 4.03516L10.4203 12H10.4413ZM2 11.3333V5.701L8.299 12H2.66667C2.48986 12 2.32029 11.9298 2.19526 11.8047C2.07024 11.6797 2 11.5101 2 11.3333Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoCameraDisable);
export default __webpack_public_path__ + "static/media/icon-video-camera-disable.f4fb22e528b9a3c6f2698e87e348cd5e.svg";
export { ForwardRef as ReactComponent };